import { useEffect } from 'react';
import { useRMSelector } from 'redux/hooks';
import { useGetBackgroundJobs } from 'redux/hooks/backgroundJobs';
import { selectedSystemTasksState } from 'redux/selectors/StateSelectors';
import { setTabRunningTasks } from 'utils/CrossTabBusyTracker';

const isRunning = (item: { progress?: number }) =>
  item.progress == null || item.progress < 100;

const useCrossTabBusyPublisher = () => {
  const systemTasks = useRMSelector(selectedSystemTasksState);
  const backgroundJobs = useGetBackgroundJobs();

  const runningLabels = [
    ...(systemTasks?.filter(isRunning).map((task) => `task: ${task.title}`) ?? []),
    ...(backgroundJobs?.filter(isRunning).map((job) => `job: ${job.name}`) ?? []),
  ];

  const runningKey = runningLabels.join('|');

  useEffect(() => {
    setTabRunningTasks(runningLabels);
  }, [runningKey]);
};

export default useCrossTabBusyPublisher;
